import { render, staticRenderFns } from "./JoinSelectSkeleton.vue?vue&type=template&id=53579b30&scoped=true&"
import script from "./JoinSelectSkeleton.vue?vue&type=script&lang=js&"
export * from "./JoinSelectSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./JoinSelectSkeleton.vue?vue&type=style&index=0&id=53579b30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53579b30",
  null
  
)

export default component.exports